import { render, staticRenderFns } from "./region-add-or-update.vue?vue&type=template&id=7ff53e67"
import script from "./region-add-or-update.vue?vue&type=script&lang=js"
export * from "./region-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./region-add-or-update.vue?vue&type=style&index=0&id=7ff53e67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports